export const createIdForTest = ({ componentId = '', title = '', elementId = `` }) => {
  const patientTestId = `${componentId && componentId + '-'}${title}${elementId && '-' + elementId}`
  return patientTestId
    .replace(/\s*\([^)]*\)/g, '')
    .replaceAll(' ', '-')
    .toLowerCase()
}
